import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export default function LearnMoreModal() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      Strong and consistent growth rate numbers over many years indicate that a business has a durable competitive advantage in the market.
      A growth rate number of 10% or higher is considered very good. <a href="" onClick={handleClickOpen}> Learn More</a>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Historical Growth Rates
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Our model is designed to identify high cashflow generating businesses that are stable and predictable with a durable competitive advantage over the competition.
          </Typography>
          <Typography gutterBottom>
            To determine if a business has a durable competitive advantage in the market, we analyze the last 10 years of the company's financials.
          </Typography>
          <Typography gutterBottom>
            We look at the growth rate (CAGR) of the company's revenue, operating cash flow,  net income, and shareholder's equity for 1, 3, 5, 7, and 10 years.
          </Typography>
          <Typography variant="h5">
            What to look for in the Growth Rate Numbers
          </Typography>
          <Typography gutterBottom>
            <ul>
              <li>A growth rate of 10% or higher is impressive</li>
              <li>The higher the growth rate number the better</li>
              <li>High growth rate numbers that are consistent indicates a durable competitive advantage</li>
              <li>Its a good sign if the numbers are growing</li>
            </ul>
          </Typography>
          <Typography variant="h5">
            Limitations
          </Typography>
          <Typography gutterBottom>
            Share buybacks can lower the equity growth rate of a business. A company with very aggressive share buybacks can even have negative historical equity growth.
          </Typography>
          <Typography gutterBottom>
            For additional reading see here <a href="https://decode-investing.medium.com/how-to-identify-a-wonderful-business-6f7afdc6a5c6">How to identify a wonderful business</a>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
